import { useState, useEffect } from 'react';
import { useTenant } from '@tectonics/commons/tenant';
import { useEnrollment } from '../context';
import { fetchBankList } from '../services/enrollment-api';
import type { BankItem } from '../types';

interface UseBankListResult {
  readonly banks: BankItem[];
  readonly loading: boolean;
  readonly error: string | null | undefined;
}

export function useBankList(): UseBankListResult {
  const { data } = useEnrollment();
  const tenant = useTenant();
  const [banks, setBanks] = useState<BankItem[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null | undefined>(null);

  useEffect(() => {
    let cancelled = false;

    async function loadBanks() {
      try {
        setLoading(true);
        setError(null);
        const result = await fetchBankList(data.contract, tenant.code);
        if (!cancelled) {
          setBanks(result);
        }
      } catch (err) {
        if (!cancelled) {
          setError(
            typeof err === 'object'
              && err !== null
              && 'message' in err
              && typeof err.message === 'string'
              ? err.message || 'Falha ao carregar lista de bancos.'
              : 'Falha ao carregar lista de bancos.',
          );
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    loadBanks();

    return () => { cancelled = true; };
  }, [data.contract, tenant.code]);

  return { banks, loading, error };
}
